/** 站点相关公共接口 */
import request from '@/utils/util.request';

/*
 *  (site) 500错误上报
 *  @param {string} result: 错误内容
 */
export const ajax_error = (data) => {
	return request({
		url: '/site/ajaxerror',
		data,
		loading: false,
	});
};

/*
 *  (feedback) 反馈意见提交
 */
export const feedback_submit = (data) => {
	return request({
		url: '/feedback/submit',
		data,
	});
};
